export const validateMaxChar = (maxChar: number) => (rule, value, callback) => {
    if (value && value.length > maxChar) {
        callback(`Max ${maxChar} characters`);
    } else {
        callback();
    }
};
